<!-- =========================
     FULLSCREEN BACKGROUND
========================= -->
<div class="min-vh-100 position-relative overflow-hidden">

  <!-- Extra-dim Overlay -->
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

  <div v-if="error_message || success_message" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
    <div v-if="error_message" class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-error" role="alert">
      <div class="d-flex align-items-center gap-3 p-3">
        <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
          <i class="bi bi-exclamation-circle"></i>
        </span>
        <div class="toast-body p-0 fw-semibold lh-sm">{{ error_message }}</div>
        <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_error_message"></button>
      </div>
    </div>

    <div v-if="success_message" class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-success" role="status">
      <div class="d-flex align-items-center gap-3 p-3">
        <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
          <i class="bi bi-check2-circle"></i>
        </span>
        <div class="toast-body p-0 fw-semibold lh-sm">{{ success_message }}</div>
        <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss success message" @click="clear_success_message"></button>
      </div>
    </div>
  </div>

  <!-- =========================
       CONTENT LAYER
  =========================== -->
  <div class="container position-relative z-1 min-vh-100 d-flex align-items-center justify-content-center">
    <div class="row justify-content-center align-items-center w-100">

      <!-- =========================
           RESET PASSWORD (Glass Card)
      =========================== -->
      <div
        class="glass-card p-4 p-md-5 rounded-4 shadow-sm
               col-12 col-sm-8 col-md-6 col-lg-5 col-xl-5 mx-auto"
      >

        <!-- Logo -->
        <div class="text-center mb-3">
          <router-link
            to="/"
            class="auth-logo mb-2 text-decoration-none d-inline-block"
            aria-label="Bolide Home"
          ></router-link>
        </div>

        <!-- Heading -->
        <h3 class="fw-bold mb-1 text-center text-white">
          Reset Password
        </h3>

        <p class="text-center text-white-50 mb-4 text-sm">
          Enter your email and we’ll send you a link to reset your password.
        </p>

        <!-- LOADING STATE -->
        <div v-if="is_loading" class="text-center mb-3">
          <div class="spinner-border spinner-border-sm me-2 text-primary"></div>
          <span class="text-white-50">Sending reset link...</span>
        </div>

        <!-- =========================
              RESET FORM
        =========================== -->
        <form @submit.prevent="handleReset" v-if="!is_loading">

          <!-- Email -->
          <div class="mb-3">
            <label class="form-label text-xs text-white-50">Email</label>
            <input
              v-model="email"
              type="email"
              class="form-control form-control-sm rounded-3
                     bg-transparent text-white border-secondary placeholder-white"
              placeholder="Enter your email"
              required
              :disabled="is_loading"
            />
          </div>

          <button
            class="btn btn-primary w-100 rounded-3 fw-light text-xs mb-3"
            :disabled="is_loading"
          >
            Send Reset Link
          </button>

          <!-- Back to Login -->
          <p class="text-center text-white-50 text-xs mb-0">
            Remember your password?
            <router-link to="/login" class="text-decoration-none text-primary">
              Login
            </router-link>
          </p>

        </form>

      </div>
    </div>
  </div>
</div>

